import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { Button, IconButton, Stack } from '@mui/material';

import { CustomerLogo } from '@shared/components/display/CustomerLogo';
import { useCustomer } from '@contexts/CustomerContext';

interface TopNavBarProps {
  onShowCart: () => void;
  itemCount: number;
}

export const TopNavBar = ({ onShowCart, itemCount }: TopNavBarProps) => {
  const { branding } = useCustomer();

  const openBrandSite = (): void => {
    window.open(branding.homepageUrl, '_blank');
  };

  return (
    <Paper component="header" variant="navTopBar">
      <Container>
        <Stack
          className="NavTopBar-row"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <IconButton onClick={openBrandSite}>
            <CustomerLogo inheritViewBox className="NavTopBar-logo" />
          </IconButton>

          <Button variant="navCartAction" onClick={onShowCart} startIcon={<ShoppingCartOutlinedIcon />}>
            <Typography variant="label.button" className="NavTopBar-cartCount">
              {itemCount}
            </Typography>
          </Button>
        </Stack>
      </Container>
    </Paper>
  );
};
